import legalContent from './legalContent.json';
import { legalPageToMarkdown } from './legalMarkdown';

export type LegalPolicyId = 'privacy' | 'terms' | 'cookies';

export const LEGAL_DOCUMENTS: Record<
  LegalPolicyId,
  { title: string; markdown: string }
> = {
  privacy: {
    title: legalContent.privacyPolicy.title,
    markdown: legalPageToMarkdown(legalContent.privacyPolicy),
  },
  terms: {
    title: legalContent.termsAndConditions.title,
    markdown: legalPageToMarkdown(legalContent.termsAndConditions),
  },
  cookies: {
    title: legalContent.cookiePolicy.title,
    markdown: legalPageToMarkdown(legalContent.cookiePolicy),
  },
};
